import React, { FC } from "react";

const ForgotPassword: FC = () => {
 

  return (
    <div>
  
      <form>
        <div className="mb-3">
          <label htmlFor="email" className="form-label LabelText mb-1">
            Username<span className="text-danger">*</span>
          </label>
          <input
            type="email"
            
            className="form-control bg-white text-dark border-secondary"
            id="email"
          />
        </div>
        
        <button
          type="submit"
          className="btn btn-primary w-100 mt-4"
          style={{
            backgroundColor: "#777777", 
            border: "none",
            padding: "10px",
            color: "#fff", 
          }}
        >
          Submit
        </button>
      </form>

    </div>
  );
};

export default ForgotPassword;